<template>


      <section class="bg-[#76568A] py-20 text-center text-white mt-20 pb-36">


        <div class="max-w-[1140px] mx-auto text-center mb-12">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
          Oferta por Tempo Limitado
        </h2>
        <p class="text-sm">
          Garanta agora seu plano com condições únicas! Perfeito para projetos que precisam de performance com o melhor custo-benefício do mercado.
        </p>
      </div>


        <div class="bg-white rounded-2xl overflow-hidden shadow-md max-w-6xl mx-auto pb-10 mt-20 p-12">
          <table class="w-full text-sm text-gray-800 border-separate border-spacing-0">
            <thead>
              <tr class="text-left text-sm font-semibold text-gray-700 border-b border-gray-300 ">
                <th class="p-4"></th>
                <th class="p-4 ">DISCO</th>
                <th class="p-4 border-l border-gray-300">CPU</th>
                <th class="p-4 border-l border-gray-300">MEMÓRIA</th>
                <th class="p-4 border-l border-gray-300">VALOR</th>
                <th class="p-4 border-l border-gray-300"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="plano in planos" :key="plano.id" class="border-t border-gray-300 divide-y ">
                <td class="p-4 align-top  ">
                  <div class="font-bold text-base text-black uppercase  ">{{ plano.nome }}</div>
                  <span class="text-xs bg-yellow-400 text-black font-bold px-2 py-1 rounded mt-1 inline-block">ÚLTIMAS UNIDADES</span>
                </td>
                <td class="p-4  align-top">{{ plano.disco }}</td>
                <td class="p-4 border-l border-gray-300 align-top">{{ plano.processamento }}</td>
                <td class="p-4 border-l border-gray-300 align-top">{{ plano.ram1 }} {{ plano.ram2 }}</td>
                <td class="p-4 border-l border-gray-300 align-top">
                  <div class="text-lg font-semibold">R$ {{ calcularDesconto(plano) }}</div>
                  <div class="text-sm text-gray-500">/ mês</div>
                </td>
                <td class="p-4 border-l border-gray-300 align-top">
                  <router-link
                    :to="gerarLink(plano)"
                    class="bg-cormenubotaoplanos text-white px-6 py-2 rounded-full font-semibold hover:brightness-110 transition mb-2 inline-block"
                  >
                    ASSINE JÁ
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/services/api'
import { periodoSelecionadoVpsIcp } from '@/store/periodoStore'

const planos = ref([])

function gerarLink(plano) {
  if (!plano || !plano.planoTipo) return '/';

  if (plano.planoTipo.startsWith('PROMOCIONAL-HOSPEDAGEM-PHP')) {
    return `/assineja-vps?planoId=${plano.id}`;
  }

  if (plano.planoTipo === 'PROMOCIONAL-HOSPEDAGEM-REVENDA') {
    return `/assineja-dedicado?planoId=${plano.id}`;
  }

  if (plano.planoTipo.startsWith('PROMOCIONAL-DEDICADO')) {
    return `/assineja-vps-linux-dedicado?planoId=${plano.id}`;
  }
  
  if (plano.planoTipo === 'PROMOCIONAL-HOSPEDAGEM-JAVA') {
    return `/assineja-hospedagem-java?planoId=${plano.id}`;
  }

  if (plano.planoTipo === 'PROMOCIONAL-HOSPEDAGEM-NODE') {
    return `/assineja-hospedagem-nodejs?planoId=${plano.id}`;
  }

  if (plano.planoTipo === 'PROMOCIONAL-VPS-ICP') {
    return `/assineja-vps-icp?planoId=${plano.id}`;
  }

  if (plano.planoTipo === 'PROMOCIONAL-VPS-CPANEL') {
    return `/assineja-vps-cpanel?planoId=${plano.id}`;
  }

  if (plano.planoTipo === 'PROMOCIONAL-VPS-LINUX') {
    return `/assineja-vps-linux-dedicado?planoId=${plano.id}`;
  }

  return `/`; 
}


onMounted(async () => {
  try {
    const response = await axios.get('/api/planos/listarativos')
    planos.value = response.data
        .filter(p => p.ativo)
        .filter(p => p.planoTipo && p.planoTipo.startsWith('PROMOCIONAL'))
        .sort((a, b) => a.ordem - b.ordem)
  } catch (error) {
    console.error('Erro ao buscar planos:', error)
  }
})

const formatPreco = valor => Number(valor).toFixed(2).replace('.', ',')

const getDescontoPercentual = plano => {
  if (periodoSelecionadoVpsIcp.value === '6') return plano.desconto2 || 0
  if (periodoSelecionadoVpsIcp.value === '12') return plano.desconto3 || 0
  return plano.desconto1 || 0
}

const calcularDesconto = plano => {
  const descontoPercentual = getDescontoPercentual(plano)
  const valorComDesconto = plano.valor * (1 - descontoPercentual / 100)
  return formatPreco(valorComDesconto)
}
</script>
